// Jedna rama, w której stoją wszystkie ekrany logowania, hasła i rejestracji
// (artboardy 04a–06d; R2, rozstrzygnięcie 5).
//
// TA SAMA ciemna scena, co strona główna — `--stage-deep` z tym samym światłem —
// a na niej lockup i JASNA KARTA 440 px. Panel boczny z atrapą telefonu i zdaniem
// o pliku zniknął: był jedyną treścią, której nikt tu nie czytał, a na 880 px i tak
// się chował, więc kompozycja i tak musiała działać bez niego.
//
// Linki prawne (Regulamin, Prywatność, Zgłoś treść) są przypięte do dolnej krawędzi
// sceny: zgłoszenie treści z art. 16 DSA musi być osiągalne także stąd, bo ktoś, kto
// zgłasza cudzy materiał, trafia na ekran logowania równie często jak na stronę główną.
//
// 390: ciemny pas 64 px z lockupem, karta wypełnia resztę ekranu, a główny przycisk
// siedzi w strefie kciuka (`margin-top: auto` w `minimal-public.css`) — formularz NIE
// dostaje przyklejonego paska, bo klawiatura zasłania dół ekranu (decyzja 8).

import type { ReactNode } from 'react'
import { Link } from 'react-router'
import LangSwitcher from './LangSwitcher'
import Logo from './Logo'
import { useT } from '../lib/i18n'
import { usePublicPath } from '../lib/publicPaths'
import { useAppTouchScope } from '../lib/touchGuard'
import '../styles/minimal-public.css'

export default function AuthShell({ children }: { children: ReactNode }) {
  const t = useT()
  const pub = usePublicPath()
  // Logowanie i rejestracja należą do aplikacyjnej połowy kontraktu dotyku
  // (MINIMAL-2026-09-18): bez przybliżania, bez zaznaczania powłoki, pola 16 px.
  useAppTouchScope()

  return (
    <div className="mp">
      <div className="mp-dark mp-auth">
        <LangSwitcher variant="segments" />
        <main className="mp-auth-wrap">
          <Link to={pub()} className="logo" aria-label="EDIMI"><Logo size={26} /></Link>
          <div className="mp-auth-card">{children}</div>
        </main>
        <nav className="mp-auth-legal">
          <Link to={pub('/regulamin')} target="_blank" rel="noreferrer noopener">{t('landing.footer.terms')}</Link>
          <Link to={pub('/polityka')} target="_blank" rel="noreferrer noopener">{t('landing.footer.privacyShort')}</Link>
          <Link to={pub('/zgloszenie')} target="_blank" rel="noreferrer noopener">{t('landing.footer.report')}</Link>
        </nav>
      </div>
    </div>
  )
}
